import { Card, CardContent } from "@/components/ui/card";

export function StatCard({ title, value, value2, sub, large }: { title: string; value: string; value2?: string; sub?: string; large?: boolean }) {
  const valueEl = value2 ? (
    <div className="mt-1 flex items-baseline gap-3">
      <span className={large ? "text-4xl font-bold tabular-nums" : "text-2xl font-bold"}>{value}</span>
      <span className="text-lg text-muted-foreground">/</span>
      <span className={large ? "text-4xl font-bold tabular-nums" : "text-2xl font-bold"}>{value2}</span>
    </div>
  ) : (
    <p className={large ? "mt-1 text-4xl font-bold tabular-nums" : "mt-1 text-2xl font-bold"}>{value}</p>
  );
  return (
    <Card>
      <CardContent className={large ? "px-6 pt-5 pb-4" : "pt-4 pb-3 px-4"}>
        <p className={large ? "text-sm text-muted-foreground" : "text-xs text-muted-foreground"}>{title}</p>
        {valueEl}
        {sub && <p className={large ? "mt-1 text-sm text-muted-foreground" : "text-xs text-muted-foreground"}>{sub}</p>}
      </CardContent>
    </Card>
  );
}
